import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IGlobalLoadingState {
    loading: boolean;
    isRegisteredToken: boolean;
}

const initialState: IGlobalLoadingState = {
    loading: false,
    isRegisteredToken: false,
};

export const globalLoadingSlice = createSlice({
    name: "userClaims",
    initialState,
    reducers: {
        setGlobalLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setIsRegisteredToken: (state, action: PayloadAction<boolean>) => {
            state.isRegisteredToken = action.payload;
        },
        resetGlobalLoading: () => initialState,
    },
});

export const { resetGlobalLoading, setGlobalLoading, setIsRegisteredToken } = globalLoadingSlice.actions;

export default globalLoadingSlice.reducer;
